module.exports = __webpack_public_path__ + "img/noTest.d180ec5a.svg";